import React from 'react';
import Banner from '../../../../../../UI/Banner/Banner';
import bannerImage from "../../../../../../../assets/images/satellite/banner.png";
const OutsourcingCostBanner = (props) => (
    <Banner
        id="outsourcing-cost-banner"
        className="banner black pb-5 services-banner"
        title="services:outsourcingCost.section-1.title"
        text="services:outsourcingCost.section-1.txt"
        t={props.t}
        imageBannerRight={bannerImage}
        timeDelay={1.55}
        noText
    />
);

export default OutsourcingCostBanner;
